module.exports = __webpack_public_path__ + "static/media/background.ad534226.svg";